import { useClaims } from "../auth/useClaims";

/**
 * Global masters (Department/HR-Designation/Deductions/Holidays/Tax) each
 * now have their own page-wise permission triad, {page}.Create/.Edit/.View
 * (handoff §13.3, replacing the old single Payroll.ManageMasters code).
 * Reading (`.View`) is gated at the route level (see PermissionRoute usage
 * in AppRoutes.jsx) so a page only ever mounts once the caller has it.
 * Writing (`.Create`/`.Edit`) additionally requires the caller to be an
 * all-branch admin - checked twice server-side (route + service), mirrored
 * here so the UI doesn't show controls that will just 403. Create and Edit
 * are separate permissions a role can hold independently (e.g. Edit without
 * Create is a valid combination - can update existing rows, can't add new
 * ones), so callers must check the one that matches what they're gating.
 */
export const useMasterPermissions = (page) => {
  const { permissions, isAllBranches } = useClaims();
  return {
    canCreate: permissions.includes(`${page}.Create`) && isAllBranches,
    canEdit: permissions.includes(`${page}.Edit`) && isAllBranches,
  };
};
